export default __webpack_public_path__ + "static/media/image00001-min.47d5a82d.jpeg";